import {
  Grid,
  Typography,
  Box,
  Button,
  Select,
  TextField,
  MenuItem,
  CircularProgress,
  Chip,
} from "@mui/material";
import { useEffect, useState } from "react";
import PageLayout from "../common/PageLayout";
import { useDispatch, useSelector } from "react-redux";
import { BsFiles } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import EntryTable from "../entries/EntryTable";
import { AppReviewRepository } from "../repositories/AppReviewRepository";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Transliteration } from "../common/Transliteration";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/mk";
import { TbFilterOff } from "react-icons/tb";
import ReviewTable from "./ReviewTable";
import { themeConfig } from "../../config/ThemeConfig";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";

const filterLabels = {
  trackingNumber: "Идентификатор",
  applicantName: "Подносител",
  dateSubmitted: "Датум на поднесување",
  status: "Статус",
};

export default function CompletedReviews() {
  const location = useLocation();
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [orderBy, setOrderBy] = useState("id");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [searchParams, setSearchParams] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    getAll(page, size, searchParams, orderBy, orderDirection);
  }, [page, size, orderBy, orderDirection]);

  const getAll = (page, size, searchParams, orderBy, orderDirection) => {
    setLoading(true);
    AppReviewRepository.getAllReviews(page, size, "completed", searchParams)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
        console.error(err);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setSize(newSize);
    setPage(0);
  };

  const handleChange = (name, value) => {
    let tmp = { ...searchParams };
    tmp[name] = value;
    setSearchParams(tmp);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setAppliedFilters({ ...searchParams });
      getAll(page, size, searchParams, orderBy, orderDirection);
    } else if (event.key === "Escape") {
      setSearchParams({});
      setAppliedFilters({});
      getAll(page, size, {}, orderBy, orderDirection);
    }
  };

  return (
    <PageLayout title="Завршени барања" Icon={BsFiles} prev={location.pathname}>
      <Grid container style={{ padding: "10px 0" }}>
        <Grid
          item
          xs={12}
          style={{ padding: "10px 0", gap: "10px", display: "flex" }}
        >
          <TextField
            size="small"
            placeholder="Идентификатор"
            autoComplete="off"
            inputProps={{ spellCheck: "false" }}
            onChange={(e) => {
              handleChange("trackingNumber", e.target.value.toUpperCase());
            }}
            value={searchParams?.trackingNumber || ""}
            className="login-textfield"
            onKeyDown={handleKeyDown}
          />
          <TextField
            size="small"
            placeholder="Подносител"
            autoComplete="off"
            inputProps={{ spellCheck: "false" }}
            onChange={(e) =>
              handleChange(
                "applicantName",
                Transliteration.toUpperCyrilic(e.target.value),
              )
            }
            value={searchParams?.applicantName || ""}
            className="login-textfield"
            onKeyDown={handleKeyDown}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["day"]}
              label={"Датум на креирање"}
              value={
                searchParams?.dateCreated
                  ? dayjs(searchParams.dateCreated, "DD/MM/YYYY")
                  : null
              }
              onChange={(newValue) => {
                handleChange(
                  "dateCreated",
                  newValue ? newValue.format("DD/MM/YYYY") : null,
                );
              }}
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  size="small"
                  sx={{
                    marginTop: "5px",
                  }}
                  value={
                    params.inputProps.value
                      ? dayjs(params.inputProps.value).format("DD/MM/YYYY")
                      : ""
                  }
                />
              )}
              orientation="landscape"
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["day"]}
              label={"Датум на одлука"}
              value={
                searchParams?.dateOfDecision
                  ? dayjs(searchParams.dateOfDecision, "DD/MM/YYYY")
                  : null
              }
              onChange={(newValue) => {
                handleChange(
                  "dateOfDecision",
                  newValue ? newValue.format("DD/MM/YYYY") : null,
                );
              }}
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  size="small"
                  sx={{
                    marginTop: "5px",
                  }}
                  value={
                    params.inputProps.value
                      ? dayjs(params.inputProps.value).format("DD/MM/YYYY")
                      : ""
                  }
                />
              )}
              orientation="landscape"
            />
          </LocalizationProvider>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ padding: 0, height: 38, marginTop: "5px" }}
            onClick={() => {
              setAppliedFilters({ ...searchParams });
              getAll(page, size, searchParams, orderBy, orderDirection);
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 100,
                padding: 0,
              }}
            >
              {!loading ? (
                <Typography className="login-button-text">Пребарај</Typography>
              ) : (
                <CircularProgress size={20} id="circular-progress" />
              )}
            </Box>
          </Button>
          <Button
            variant="transparent"
            sx={{
              padding: "0 10px",
              height: 38,
              marginTop: "5px",
              border: "1px solid #d0d0d0",
            }}
            startIcon={<TbFilterOff style={{ color: "#ef233c" }} />}
            onClick={() => {
              setSearchParams({});
              setAppliedFilters({});
              getAll(page, size, {}, orderBy, orderDirection);
            }}
          >
            {!loading ? (
              <Typography
                variant="caption"
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter-Regular",
                  marginLeft: "2px",
                  color: themeConfig.palette.secondary.main,
                }}
              >
                Исчисти
              </Typography>
            ) : (
              <CircularProgress size={20} id="circular-progress" />
            )}
          </Button>
        </Grid>
        <Grid item xs={auth?.userData ? 1.3 : 1} />
        <Grid item xs={12}>
          <ReviewTable
            data={data}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            loading={loading}
            getAll={getAll}
          />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
